import { authedAxios } from "./axios";

export const get = async () => {
	const { data } = await authedAxios.get("/profile");
	return data;
};
